import { render, staticRenderFns } from "./WidgetReviewsExternalPc.vue?vue&type=template&id=41f07358"
import script from "./WidgetReviewsExternalPc.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsExternalPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports